import { Just, Nothing, range } from './util';
export function solve(problem) {
    return helper(problem, []);
    function helper(problem, currentAssignments) {
        const result = search(problem);
        switch (result.kind) {
            case 'No More Items':
                return Just(currentAssignments);
            case 'No Possible Positions For An Item':
                return Nothing();
            case 'Exactly One Position':
                return helper(withItemInPosition(problem, result.position), [...currentAssignments, result.position]);
            case 'Need To Try All Positions':
                for (let position of result.item.possiblePositions) {
                    const namedPosition = {
                        id: result.item.id, spacesTaken: position.spacesTaken
                    };
                    const maybePositions = helper(withItemInPosition(problem, namedPosition), [...currentAssignments, namedPosition]);
                    if (maybePositions.kind === 'Just') {
                        return maybePositions;
                    }
                }
                return Nothing();
        }
    }
}
function withItemInPosition(problem, position) {
    return removeSpaces({ items: problem.items.filter(item => item.id !== position.id) }, [...position.spacesTaken.values()]);
}
function removeSpaces(problem, spaces) {
    return {
        items: problem.items.map(item => ({
            id: item.id,
            possiblePositions: item.possiblePositions.filter(position => !spaces.some(space => position.spacesTaken.has(space)))
        }))
    };
}
function search(problem) {
    if (problem.items.length === 0) {
        return { kind: 'No More Items' };
    }
    for (let item of problem.items) {
        if (item.possiblePositions.length === 0) {
            return { kind: 'No Possible Positions For An Item' };
        }
        if (item.possiblePositions.length === 1) {
            return { kind: 'Exactly One Position', position: { id: item.id, spacesTaken: item.possiblePositions[0].spacesTaken } };
        }
    }
    return { kind: 'Need To Try All Positions', item: problem.items[0] };
}
export function toBox(positions, width, height) {
    let squares = range(width).map(i => range(height).map(j => 0));
    for (let position of positions) {
        for (let space of position.spacesTaken.values()) {
            const { x, y } = fromNumber(space, width);
            squares[x][y] = position.id;
        }
    }
    return {
        width,
        height,
        squares
    };
}
function fromNumber(n, width) {
    return {
        x: n % width,
        y: Math.floor(n / width)
    };
}
